import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private _cookieService: CookieService,
    private _router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._cookieService.get('token')) {
      // console.log('authenticated!..', this._cookieService.get('token'));
      console.log('authenticated!..');
      return true;
    } else {
      // console.log('Not authenticated!', this._cookieService.get('token'));
      console.log('Not authenticated!');
      return this._router.createUrlTree(['auth']);
    }
  }
}
